class CardModal extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(window, 'load', this.setupModal.bind(this))
    this.listeners.add(document, 'click', this.handleModalTrigger.bind(this))
  }

  setupModal () {
    this.els.close.elements.forEach((close) => {
      close.addEventListener('click', this.handleModalClose.bind(this))
    })

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.BEFORE_ADD_FROM_FORM,
      this.buyModalClose.bind(this),
    )

    this.addEventListener('click', (e) => {
      if (e.target !== this) return

      this.setAttribute('aria-hidden', 'true')
    })
  }

  async handleModalTrigger (event) {
    const trigger = event.target.closest(
      '[data-card-modal-external-el="trigger"]',
    )
    if (!trigger) return

    this.els.modal.element.setAttribute('aria-hidden', 'false')
    this.els.async.element.setAttribute('data-url', trigger.dataset.product)
    this.els.async.element.setAttribute(
      'data-product-id',
      trigger.dataset.productId,
    )
    await this.els.async.element.initialise()

    this.sendCSEvent(true)

    const heading = this.els.modal.element.querySelector(
      '[data-card-modal-heading-el]',
    )

    if (trigger.dataset.productPreorder) {
      heading.textContent = window.theme.strings.quickBuyModalHeaderPreorder
    } else {
      heading.textContent = window.theme.strings.quickBuyModalHeaderRegular
    }
  }

  handleModalClose = () => {
    this.els.modal.element.setAttribute('aria-hidden', 'true')
    this.sendCSEvent(false)
  }

  buyModalClose = (event) => {
    if (!event.detail.form.getAttribute('key') === 'card') return
    this.els.modal.element.setAttribute('aria-hidden', 'true')
  }

  sendCSEvent (isOpen) {
    window._uxa = window._uxa || []
    const locationURL = isOpen
      ? `${
          window.location.search + (window.location.search ? '&' : '?')
        }quick-add`
      : window.location.search

    window._uxa.push(['setQuery', locationURL])

    window._uxa.push([
      'trackPageview',
      window.location.pathname + window.location.hash.replace('#', '?__'),
    ])

    if (isOpen) {
      window._uxa.push(['setQuery', window.location.search])
    }
  }
}

if (!customElements.get('card-modal')) {
  customElements.define('card-modal', CardModal)
}
